module.exports = __webpack_public_path__ + "img/FR14749.8efac759.png";